import { createAsyncThunk } from '@reduxjs/toolkit';
import { updateUserActiveEmployer } from './updateUserActiveEmployer.thunk';

export const handleChangeActiveEmployer = createAsyncThunk(
  'user/handleChangeActiveEmployer',
  async (
    { activeEmployerId, history, navigateToEmployer = false },
    { dispatch }
  ) => {
    await dispatch(
      updateUserActiveEmployer({
        activeEmployerId,
        history,
        navigateToEmployer,
      })
    );
  }
);
